<!--MeetingSetupPopUpHtml-->
<div class="popup-backdrop" (click)="PopupEvent('close')" *ngIf="popup?.Display">
</div>
<div class="popup-component" *ngIf="popup?.Display">
  <div class="popup-container service-setup-popup meeting-setup-popup">
    <div class="popup-content" style=" width: 50vw; min-width: 300px;">
      <!-- popup header -->
      <div class="popup-header">
        <h2>{{ popup?.Title }}</h2>
      </div>

      <!--popup setup form-->
      <div class="popup-body popup-setup-form" *ngIf="PopupAction == 'Setup'">
        <div class="column">
          <!--<div class="meeting-form column">-->
          <div class="form-group row justify-space-between align-center gap-20">
            <label>Title:</label>
            <app-custom-dropdown [options]="appointmentTypes"
                                 [placeholder]="'Select Type'"
                                 [(ngModel)]="aapointment.ServiceProviderID"
                                 [optionsText]="'Name'"
                                 [optionsValue]="'ID'">
            </app-custom-dropdown>
          </div>
          <hr />
          <div class="column">
            <div class="form-group row justify-space-between align-center gap-20">
              <label for="required">Required:</label>
              <div class="multiselect-container" style="width: 85%;">
                <!-- Display selected users -->
                <div class="selected-users">
                  <span *ngFor="let user of selectedRequiredUsers">
                    {{ user.Name }} {{ user.Surname }} <button (click)="removeRequiredUser(user)">x</button>
                  </span>
                </div>
                <!-- Input for search -->
                <input type="text" placeholder="Search users" [(ngModel)]="searchRequiredQuery" (input)="filterUsers()" class="input-control" style="margin: 0px;" />
                <!-- Dropdown list of users -->
                <div>
                  <ul class="selected-user-dropdown">
                    <li *ngFor="let user of filteredRequiredUsers" class="row">
                      <label class="checkbox-control">
                        {{ user.Name }} {{ user.Surname }}
                        <input type="checkbox" [checked]="isRequiredSelected(user)" (change)="toggleRequiredUser(user)" />
                        <span class="checkbox-indicator"></span>
                        <span class="checkbox-indicator-container"></span>
                      </label>     
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!--<hr />-->
            <div class="form-group row justify-space-between align-center gap-20">
              <label for="optional">Optional:</label>
              <div class="multiselect-container" style=" width: 85%;">
                <!-- Display selected users -->
                <div class="selected-users">
                  <span *ngFor="let user of selectedOptionalUsers">
                    {{ user.Name }} {{ user.Surname }} <button (click)="removeOptionalUser(user)">x</button>
                  </span>
                </div>

                <!-- Input for search -->
                <input type="text" placeholder="Search users" [(ngModel)]="searchOptionalQuery" (input)="filterUsers()" class="input-control" style="margin: 0px;" />

                <!-- Dropdown list of users -->
                <div>
                  <ul class="selected-user-dropdown">
                    <li *ngFor="let user of filteredOptionalUsers" class="row">
                      <label class="checkbox-control">
                        {{ user.Name }} {{ user.Surname }}
                        <input type="checkbox" [checked]="isOptionalSelected(user)" (change)="toggleOptionalUser(user)"/>
                        <span class="checkbox-indicator"></span>
                        <span class="checkbox-indicator-container"></span>
                      </label>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
          </div>
          <hr />
          <div class="column gap-30">
            <div class="row">
              <div class="form-group column gap-10">
                <label>Date:</label>
                <app-calendar-dropdown [(selectedDate)]="recurrenceStartDate"></app-calendar-dropdown>
              </div>
            </div>
            <div class="row gap-10 align-center justify-space-between">
              <div class="form-group column gap-10">
                <label>Start Time</label>
                <app-custom-dropdown [options]="times"
                                     [placeholder]="'Select time'"
                                     [(ngModel)]="selectedStartRecurringTime"
                                     [optionsText]="'Type'"
                                     [optionsValue]="'Type'"
                                     (ngModelChange)="SingleTimeSelectionValidation()">
                </app-custom-dropdown>
              </div>
              <div class="form-group column gap-10">
                <label>End Time</label>
                <app-custom-dropdown [options]="times"
                                     [placeholder]="'Select time'"
                                     [(ngModel)]="selectedEndRecurringTime"
                                     [optionsText]="'Type'"
                                     [optionsValue]="'Type'"
                                     (ngModelChange)="SingleTimeSelectionValidation()">
                </app-custom-dropdown>
              </div>
              <div class="form-group">
                <label for="all-day" class="checkbox-control">
                  All Day
                  <input type="checkbox" id="all-day" name="all-day" [(ngModel)]="isAllDay" (change)="allDayTimeSet()" />
                  <span class="checkbox-indicator"></span>
                  <span class="checkbox-indicator-container"></span>
                </label>
              </div>
            </div>
            <div class="form-group row gap-10">
              <button type="button" id="make-recurring" class="make-recurring" (click)="navigateToRecurrence()" style="cursor: pointer">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
                  <g clip-path="url(#clip0_155_1848)">
                    <path d="M15.7144 12.8574L18.5715 12.1431L19.2858 15.0002" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M18.5715 12.1431C17.964 13.9579 16.8186 15.5449 15.2876 16.6932C13.7565 17.8415 11.9123 18.4966 10 18.5716C8.24017 18.5719 6.52289 18.0306 5.08141 17.0211C3.63994 16.0115 2.54414 14.5828 1.94287 12.9288" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M4.28578 7.14286L1.42864 7.85714L0.714355 5" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M1.42871 7.85728C2.0681 6.06232 3.22197 4.49544 4.74631 3.35217C6.27065 2.20891 8.09795 1.53993 10.0001 1.42871C11.7686 1.43368 13.4921 1.98551 14.9346 3.00854C16.3771 4.03157 17.4679 5.47571 18.0573 7.143" stroke="#004D8B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </g>
                  <defs>
                    <clipPath id="clip0_155_1848">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <label for="make-recurring" style="cursor: pointer;">Make Recurring</label>
            </div>
            <div class="form-group row gap-20 align-center" *ngIf="aapointment.ServiceProviderID != 34">
              <label for="location">Location:</label>
              <app-custom-dropdown [options]="serviceAreas"
                                   [placeholder]="'Select a location'"
                                   [(ngModel)]="selectedServiceAreaID"
                                   [optionsText]="'ServiceAreaName'"
                                   [optionsValue]="'ID'"
                                   class="w-45">
              </app-custom-dropdown>
              <!--<select id="location" name="location" [(ngModel)]="selectedServiceAreaID">
        <option [ngValue]="null">Select a location</option> .form-container meeting-form
        <option *ngFor="let serviceArea of serviceAreas" value={{serviceArea.ID}}>{{ serviceArea.ServiceAreaName }}</option>
      </select>-->
            </div>
            <div *ngIf="showError == true" class="error-popup row">
              <h3 class="error-message">* {{erroMessage}}</h3>
            </div>
            <div class="popup-buttons">
              <button type="button" class="popup-btn" (click)="AltButtonClick()">Cancel</button>
              <button type="submit" class="popup-btn" (click)="generateSingleAppointmentForStaff()">Save</button>
            </div>
          </div>
        </div>
        </div>
      <!--popup setup form-->
      <div class="popup-body popup-setup-form" *ngIf="PopupAction == 'Recurrence'">
        <div class="form-container column gap-30">
          <div class="recurrence-form column gap-10">
            <div class="title row">
              <h3 for="appointment-time" style="font-weight: 500; font-size: 19px;">Appointment Time:</h3>
            </div>
            <div class="column gap-20">
              <div class="form-group column gap-10" style="width: 200px;">
                <label>Start Time</label>
                <app-custom-dropdown [options]="times"
                                     [placeholder]="'Select time'"
                                     [(ngModel)]="selectedStartRecurringTime"
                                     [optionsText]="'Type'"
                                     [optionsValue]="'Type'"
                                     (ngModelChange)="MultiTimeSelectionValidation()">
                </app-custom-dropdown>
              </div>
              <div class="form-group column gap-10" style="width: 200px;">
                <label>End Time</label>
                <app-custom-dropdown [options]="times"
                                     [placeholder]="'Select time'"
                                     [(ngModel)]="selectedEndRecurringTime"
                                     [optionsText]="'Type'"
                                     [optionsValue]="'Type'"
                                     (ngModelChange)="MultiTimeSelectionValidation()">
                </app-custom-dropdown>
              </div>
            </div>
            <hr />
            <div class="title row">
              <h3 for="appointment-time" style="font-weight: 500; font-size: 19px;">Recurrence Pattern:</h3>
            </div>
            <div class="frequency-container" style="display: grid; grid-template-columns: .5fr 1fr; justify-content: center; align-items: center;">
              <ul class="radio-group column gap-10" style=" width: auto; list-style: none; padding: 0; margin: 0;">
                <li>
                  <label for="daily" class="checkbox-control">
                    Daily
                    <input type="radio" name="frequency" id="daily" value="daily" [(ngModel)]="selectedfrequency" (change)="selectDaily()">
                    <span class="checkbox-indicator"></span>
                    <span class="checkbox-indicator-container"></span>
                  </label>
                </li>
                <li>
                  <label for="weekly" class="checkbox-control">
                    Weekly
                    <input type="radio" name="frequency" id="weekly" value="weekly" [(ngModel)]="selectedfrequency">
                    <span class="checkbox-indicator"></span>
                    <span class="checkbox-indicator-container"></span>
                  </label>
                </li>
                <li>
                  <label for="monthly" class="checkbox-control">
                    Monthly
                    <input type="radio" name="frequency" id="monthly" value="monthly" [(ngModel)]="selectedfrequency">
                    <span class="checkbox-indicator"></span>
                    <span class="checkbox-indicator-container"></span>
                  </label>
                </li>
                <li>
                  <label for="yearly" class="checkbox-control">
                    Yearly
                    <input type="radio" name="frequency" id="yearly" value="yearly" [(ngModel)]="selectedfrequency" (change)="selectYearly()">
                    <span class="checkbox-indicator"></span>
                    <span class="checkbox-indicator-container"></span>
                  </label>
                </li>
              </ul>
              <div class="days-of-week column">
                <div class="days-of-week row">
                  <div class="day">
                    <label for="monday" class="checkbox-control">
                      Monday <input type="checkbox" id="monday" name="monday" [(ngModel)]="selectedDays.Week['monday']" (change)="onDayChange()">
                      <span class="checkbox-indicator"></span>
                      <span class="checkbox-indicator-container"></span>
                    </label>
                  </div>
                  <div class="day">
                    <label for="tuesday" class="checkbox-control">
                      Tuesday<input type="checkbox" id="tuesday" name="tuesday" [(ngModel)]="selectedDays.Week['tuesday']" (change)="onDayChange()">
                      <span class="checkbox-indicator"></span>
                      <span class="checkbox-indicator-container"></span>
                    </label>
                  </div>
                  <div class="day">
                    <label for="wednesday" class="checkbox-control">
                      Wednesday<input type="checkbox" id="wednesday" name="wednesday" [(ngModel)]="selectedDays.Week['wednesday']" (change)="onDayChange()">
                      <span class="checkbox-indicator"></span>
                      <span class="checkbox-indicator-container"></span>
                    </label>
                  </div>
                  <div class="day">
                    <label for="thursday" class="checkbox-control">
                      Thursday<input type="checkbox" id="thursday" name="thursday" [(ngModel)]="selectedDays.Week['thursday']" (change)="onDayChange()">
                      <span class="checkbox-indicator"></span>
                      <span class="checkbox-indicator-container"></span>
                    </label>
                  </div>
                  <div class="day">
                    <label for="friday" class="checkbox-control">
                      Friday<input type="checkbox" id="friday" name="friday" [(ngModel)]="selectedDays.Week['friday']" (change)="onDayChange()">
                      <span class="checkbox-indicator"></span>
                      <span class="checkbox-indicator-container"></span>
                    </label>
                  </div>
                </div>
                <div class="days-of-week row">
                  <div class="day">
                    <label for="sunday" class="checkbox-control">
                      Sunday<input type="checkbox" id="sunday" name="sunday" [(ngModel)]="selectedDays.Week['sunday']" (change)="onDayChange()">
                      <span class="checkbox-indicator"></span>
                      <span class="checkbox-indicator-container"></span>
                    </label>
                  </div>
                  <div class="day">
                    <label for="saturday" class="checkbox-control">
                      Saturday<input type="checkbox" id="saturday" name="saturday" [(ngModel)]="selectedDays.Week['saturday']" (change)="onDayChange()">
                      <span class="checkbox-indicator"></span>
                      <span class="checkbox-indicator-container"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="days-of-week" *ngIf="selectedfrequency === 'weekly' || selectedfrequency === 'monthly'">
              <div class="form-group row align-center">
                <label>Recur every</label>
                <input type="number" id="recur-every" placeholder="Select an option" style=" max-width: 53px; color: black; padding: 5px;" name="recur-every" [(ngModel)]="recurrence" min="1" value="1" class="input-control" />
                <label for="recur-every">week(s) on:</label>
              </div>
            </div>
            <hr />
            <div class="title row">
              <h3 for="appointment-time" style="font-weight: 500; font-size: 19px;">Range of recurrence:</h3>
            </div>
            <div class="row gap-30">
              <div class="form-group column gap-10">
                <label>Start:</label>
                <app-calendar-dropdown [(selectedDate)]="recurrenceStartDate"></app-calendar-dropdown>
              </div>
              <div class="form-group column gap-10">
                <label>End By:</label>
                <app-calendar-dropdown [(selectedDate)]="recurrenceEndDate"></app-calendar-dropdown>
              </div>
            </div>
            <div *ngIf="showError == true" class="error-popup row">
              <h3 class="error-message">* {{erroMessage}}</h3>
            </div>
          </div>
          <div class="popup-buttons">
            <button type="button" class="popup-btn" (click)="navigateToSetup()">Cancel</button>
            <button type="button" class="popup-btn" (click)="calculateDates()">Save</button>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
